<div class="col-sm-12 detail" *ngIf="!isEmpty && !isEdit && !isReconduire" style="height: 100%"
    (click)="common.outSide($event)">
    <div class="header col-sm-12">
        <div class="col-sm-6">
            <div class="col-sm-12 d-flex p-0">
                <div class="col-sm-9 p-0">
                    <h3 *ngIf="!isHisto"> Liste des prix negociés du client : {{detail.nomClient || ''}} </h3>
                    <h3 *ngIf="isHisto"> Historique des prix negociés du client : {{detail.nomClient || ''}} </h3>
                </div>
                <div class="col-sm-3 btn-group p-0 text-left" dropdown #dropdown="bs-dropdown" [isOpen]="status.isopen"
                    (isOpenChange)="change($event)" style="padding:4px 0;width: 11.666667%;">
                    <button type="submit" dropdownToggle class="bouton btn-filtre uppercase"
                        [matBadge]="getNbrFiltres()" matBadgeColor="primary" [matBadgeHidden]="!getNbrFiltres()">
                        Filtres
                        <i class="fa fa-chevron-down pull-right" aria-hidden="true"></i>
                    </button>
                    <ul *dropdownMenu class="dropdown-menu filtre-fact" role="menu">
                        <div class="col-sm-12" style="padding: 0;">
                            <div class="col-sm-6 title"> Chantier </div>
                            <div class="col-sm-6 title"> Agence </div>
                        </div>
                        <div class="col-sm-12" style="padding: 0 15px;">
                            <div class="col-sm-6">
                                <li role="menuitem">
                                    <a class="dropdown-item" [ngClass]="{'filter-selected': !selectedFilter.chantier}"
                                        (click)="addFiltreDynamic('chantier', 0, 'Toutes')">Toutes</a>
                                </li>
                                <li role="menuitem" *ngFor="let item of listFiltreChantier"
                                    [ngClass]="{'filter-selected': selectedFilter.chantier === item.id}"
                                    (click)="addFiltreDynamic('chantier', item.id, 'chantier')">
                                    <a class="dropdown-item"> {{item.numChantier || ''}} </a>
                                </li>
                            </div>
                            <div class="col-sm-6">
                                <li role="menuitem">
                                    <a class="dropdown-item" [ngClass]="{'filter-selected': !selectedFilter.agence}"
                                        (click)="addFiltreDynamic('agence', 0, 'Toutes')">Toutes</a>
                                </li>
                                <li role="menuitem" *ngFor="let item of listFiltreAgence"
                                    [ngClass]="{'filter-selected': selectedFilter.agence === item.id}"
                                    (click)="addFiltreDynamic('agence', item.id, 'agence')">
                                    <a class="dropdown-item"> {{item.libelleObjetEntite || ''}} </a>
                                </li>
                            </div>

                        </div>
                    </ul>
                </div>
            </div>

            <div class="text-underline historique" style="padding-right: 0px; cursor: pointer;">
                <span *ngIf="!isHisto" (click)="showHisto()"> Afficher l'historique </span>
                <span *ngIf="isHisto" (click)="showHisto()"> Afficher la liste </span>
            </div>

        </div>
        <div class="col-sm-6 text-right" style="white-space: nowrap; padding: 0px">
            <div dropdown style="display: inline !important;">
                <button type="submit" dropdownToggle class="bouton btn-filtre btn-more uppercase">
                    <div id="moremenu"> ...</div>
                </button>
                <ul *dropdownMenu class="dropdown-menu menuplus" role="menu">

                    <li role="menuitem" *ngIf="!isHisto && isDroitModifierPrixNego && !depuisDevis">
                        <button class="bouton btn-simple uppercase"  [disabled]="nepasModifierficheClient"  (click)="getListPrixDerNeg()"> Reconduire </button>
                    </li>

                    <li role="menuitem" *ngIf="!isHisto && !depuisDevis">
                        <button class="bouton btn-simple uppercase"  [disabled]="nepasModifierficheClient" 
                            (click)="familleImprimable = '8';common.openModal(modalService, verImprimable)"> Version
                            Imprimable
                        </button>
                    </li>

                    <li role="menuitem" *ngIf="depuisDevis && !depuisAutre">
                        <button class="bouton btn-simple uppercase" (click)="insertDevisFct()"> insérer dans
                            le devis
                        </button>

                    <li role="menuitem" *ngIf="!isHisto && isDroitModifierPrixNego && !depuisDevis">
                        <button class="bouton btn-simple uppercase"  [disabled]="nepasModifierficheClient"  (click)="majRetroTarif()"> MAJ retro. </button>
                    </li>

                    <li role="menuitem">
                        <button class="bouton btn-simple uppercase" (click)="extraireXls()"> Extraire en XLS </button>
                    </li>

                    <li role="menuitem" *ngIf="isDroitModifierPrixNego && !depuisDevis && !isHisto">
                        <button class="bouton btn-simple uppercase" [disabled]="nepasModifierficheClient" (click)="historiserPrixSelected()"> Historiser les
                            prix sélectionnés</button>
                    </li>
                </ul>
            </div>
            <button class="btn-header uppercase" id="close" (click)="hide()"> Fermer </button>
        </div>
    </div>

    <div class="col-sm-12 ligneBon  factautoTab tableauRefonte ligneBonRefonte  liste"
        [ngStyle]="{ 'height' : depuisDevis ? 'calc(100% - 135px)' : (isDepuisMenuEnHaut ? 'calc(100% - 252px)' : 'calc(100% - 135px)')}">
        <ngx-datatable #myTable *ngIf="renderTable" style="height: 100%" class="material"
            [rows]="listPrixNegocier || []" [columnMode]="'force'" [headerHeight]="35" [footerHeight]="0"
            [rowHeight]="auto" [selectionType]="'single'"
            [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' : 'Pas de lignes à afficher'}"
            (activate)="onActivate($event)" (scroll)="onScroll($event.offsetY, $event.offsetX)"
            [loadingIndicator]="loadingIndicator" [selected]="selected" [scrollbarH]="isScroll"
            [sorts]="common.prixNegocieTrie" (resize)="onColumnResize($event)" (sort)="onColumnSort($event)">

            <ngx-datatable-column [width]="columns[0].width" [sortable]="false" [canAutoResize]="false"
                [draggable]="false" [resizeable]="false" *ngIf="!depuisDevis && !isHisto">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn">
                    <div class="col-sm-12 p-0" style="text-align : center; position: relative;
                          top: -6px;">
                        <div class="col-sm-12 head-validBon p-0">
                            <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                                [(ngModel)]="checkedall" (change)="checkedAll($event)"
                                [disabled]="!isDroitModifierPrixNego || nepasModifierficheClient"
                                [ngClass]="{'regular-checkbox-checked': checkedall}" />
                        </div>
                        <div class="col-sm-12 p-0 textValiderBon">
                            <span> Sel </span>
                        </div>
                    </div>
                </ng-template>
                <ng-template ngx-datatable-cell-template let-row="row">
                    <div class="col-sm-12 p-0 text-center">
                        <input type="checkbox" id="checkbox-1-1" class="regular-checkbox" [(ngModel)]="row.isChecked"
                            [disabled]="!isDroitModifierPrixNego || nepasModifierficheClient"
                            (change)="checkedRow(row, $event);"
                            [ngClass]="{'regular-checkbox-checked': row.isChecked}" />
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column [width]="columns[0].width" [sortable]="false" [canAutoResize]="false"
                [draggable]="false" [resizeable]="false" *ngIf="!depuisDevis && !isHisto">
                <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                    <div class="text-center">
                        <button *ngIf="isDroitModifierPrixNego" class="btn-detail" (click)="editRow(row);"
                            [disabled]="nepasModifierficheClient">
                            <i class="fa fa-pencil"></i>
                        </button>
                    </div>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="article.code"
                [width]="(!depuisDevis && !isHisto) ? columns[1].width: columnsHisto[0].width"
                [cellClass]="getCellClass">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Article </span>
                        <div class=" col-sm-1 pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="artLibelle" [cellClass]="getCellClassOther"
                [width]="(!depuisDevis && !isHisto) ? columns[2].width: columnsHisto[1].width">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Description </span>
                        <div class=" col-sm-1 pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="codeBanque" prop="article.unite" [cellClass]="getCellClassOther"
                [width]="(!depuisDevis && !isHisto) ? columns[3].width: columnsHisto[2].width">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Unite </span>
                        <div class=" col-sm-1 pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="tarif" prop="tarif" [cellClass]="getCellClassOther"
                [width]="(!depuisDevis && !isHisto) ? columns[4].width: columnsHisto[3].width">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Tarif </span>
                        <div class=" col-sm-1 pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="row.isTarifQte" (mouseenter)="articleHover = row.article" [popover]="popTemplate"
                        [container]="'body'" [containerClass]="'contenantPopoevr'" triggers="mouseenter:mouseleave"> TQ
                    </div>
                    <div *ngIf="!row.isTarifQte">
                        {{common.toFixed((value || '0'), 3)}}
                    </div>

                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="dateDebut" prop="modelDebut" [cellClass]="getCellClassOther"
                [width]="(!depuisDevis && !isHisto) ? columns[5].width: columnsHisto[4].width">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase ">Début </span>
                        <div class=" col-sm-1 pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.dateDebut}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="dateFin" prop="modelFin" [cellClass]="getCellClassOther"
                [width]="(!depuisDevis && !isHisto) ? columns[6].width: columnsHisto[5].width">
                <ng-template let-col="column" ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Fin</span>
                        <div class=" col-sm-1 pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.dateFin}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="chantierLibelle" [cellClass]="getCellClassOther"
                [width]="(!depuisDevis && !isHisto) ? columns[7].width: columnsHisto[6].width">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Chantier </span>
                        <div class=" col-sm-1 pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value}}
                    <div>
                        {{row.chantierRespVille}}
                    </div>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="exutoireLibelle" [cellClass]="getCellClassOther"
                [width]="(!depuisDevis && !isHisto) ? columns[8].width: columnsHisto[7].width">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Exutoire </span>
                        <div class=" col-sm-1 pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="commentaire" [cellClass]="getCellClassOther"
                [width]="(!depuisDevis && !isHisto) ? columns[9].width: columnsHisto[8].width">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Commentaire </span>
                        <div class=" col-sm-1 pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="articleContenuLibelle" [cellClass]="getCellClassOther"
                [width]="(!depuisDevis && !isHisto) ? columns[10].width: columnsHisto[9].width">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Art. Contenu </span>
                        <div class=" col-sm-1 pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="agenceLibelle" [cellClass]="getCellClassOther"
                [width]="(!depuisDevis && !isHisto) ? columns[11].width: columnsHisto[10].width">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Agence </span>
                        <div class=" col-sm-1 pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [width]="(!depuisDevis && !isHisto) ? columns[12].width: columnsHisto[11].width"
                [cellClass]="getCellClassOther">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Contenant </span>
                        <div class=" col-sm-1 pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.contenant && row.contenant.famille ? (row.contenant.famille.libelle) : 'Tous'}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="zoneLibelle" [cellClass]="getCellClassOther"
                [width]="(!depuisDevis && !isHisto) ? columns[13].width: columnsHisto[12].width">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Zone </span>
                        <div class=" col-sm-1 pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="camionLibelle" [cellClass]="getCellClassOther"
                [width]="(!depuisDevis && !isHisto) ? columns[14].width: columnsHisto[13].width">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Matériel </span>
                        <div class=" col-sm-1 pull-right">
                            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value}}
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>

    </div>

    <div *ngIf="!depuisDevis && isDroitModifierPrixNego" class="addLigne col-sm-12 uppercase">
        <div class="col-sm-7 text-left" *ngIf="!isHisto" [ngClass]="{'disabledbutton': nepasModifierficheClient}">
            <button class="btn-add" id="addLigne" (click)="selectedRow = {};isEdit = true; addLigne()">
                <i class="fa fa-plus"></i>
            </button>
            <span (click)="selectedRow = {}; isEdit = true; addLigne()">Ajouter une ligne</span>

        </div>
        <label class="text-left uppercase text-underline historique col-sm-5"></label>
    </div>
</div>


<app-empty-detail-fact *ngIf="isEmpty" id="empty"></app-empty-detail-fact>

<div class="col-sm-12 detail" style="height: 100%; padding: 0px" *ngIf="isEdit" #formEdit
    (click)="common.outSide($event)">
    <div class="modal-header col-sm-12" style="padding: 5px;" (click)="common.outSide($event)">
        <h4 class="modal-title pull-left col-sm-8"> {{selectedRow.id ? 'Modifier un prix negocié' : 'Ajout d\'un prix
            negocié'}} </h4>
        <div class="col-sm-4 text-right">
            <button type="button" class="btn-header uppercase"
                (click)="selectedRow = {};isEdit = false;recalculWidth()"> Fermer
            </button>
            <button type="button" class="btn-header uppercase actionPricipal" (click)="valideNegoBeforeSave();">
                Valider </button>
            <div>
                <label class="text-left uppercase text-underline voir-historique"
                    (click)="common.getLogs(selectedRow.id, '135', modalService);">
                    Voir l'historique </label>
            </div>
        </div>
    </div>
    <div class="modalFicheClient col-sm-12">
        <div class="col-sm-12">
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Article :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px"
                    [ngClass]="{'disabledbutton': selectedRow.checkOperation}">
                    <app-autocomplete [placeholder]="'Article'" (searchfunction)="searchArticle($event)"
                        (selectfunction)="hideRemorque = false;selectedRow.article = $event; setValue($event)"
                        [notOblig]="true" [label]="''" [selectvalue]="true" [results]="dataArticle"
                        [id]="'modedepaie article'"
                        [defaultsearch]="selectedRow.article ? (selectedRow.article.libelle || selectedRow.article.libelleObjetEntite) : ''"
                        [autohide]="true" [dropdownclass]="'dropDownPrixNego'"
                        (keyenterfunction)="common.focusNext('.ligneBon')"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Unité :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    {{selectedRow.unite}}
                </div>
            </div>
            <div class="form-group items col-sm-12" *ngIf="!hideRemorque && isFamille2">
                <label class="col-sm-3 champ" style="padding:0px">
                    Prest. avec remorque :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <div>
                        <mat-checkbox [color]="'primary'" [(ngModel)]="selectedRow.remorque"></mat-checkbox>
                    </div>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Opération :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <div>
                        <mat-checkbox [color]="'primary'" [(ngModel)]="selectedRow.checkOperation"
                            (ngModelChange)="changeOperation(selectedRow)"></mat-checkbox>
                    </div>
                    <div class="col-sm-12" style="padding: 0px"
                        [ngClass]="{'disabledbutton': !selectedRow.checkOperation}">
                        <app-autocomplete (selectfunction)="selectedRow.operationBenne = $event;"
                            [results]="dataOperation" [highlight]="true" [id]="'modedepaie operationBenne'"
                            [isCombo]="true" [disablefocus]="true" [dropdownclass]="'dropDownPrixNego'"
                            [defaultselected]="selectedRow.operationBenne"
                            [defaultsearch]="selectedRow.operationBenne && selectedRow.operationBenne.id ? selectedRow.operationBenne.libelleObjetEntite || selectedRow.operationBenne.libelle : ''">
                        </app-autocomplete>
                    </div>
                </div>
            </div>
            <div class="form-group items col-sm-12" *ngIf="!isFamille2">
                <label class="col-sm-3 champ" style="padding:0px">
                    Seuil de fact. :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <div>
                        <mat-checkbox [color]="'primary'" [(ngModel)]="selectedRow.seuilFact"></mat-checkbox>
                    </div>
                </div>
            </div>
            <div class="form-group items col-sm-12" *ngIf="!isFamille2">
                <label class="col-sm-3 champ" style="padding:0px">
                    Seuil :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input type="text" class="form-control" id="numCompte" [(ngModel)]="selectedRow.qteSeuil"
                        autocomplete="off" (keydown.enter)="common.focusNext('.modalFicheClient')"
                        [disabled]="!selectedRow.seuilFact">
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Tarif à la quantité :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <div>
                        <mat-checkbox [color]="'primary'" [(ngModel)]="selectedRow.isTarifQte"></mat-checkbox>
                    </div>

                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Tarif :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input type="number" *ngIf="!selectedRow.isTarifQte" class="form-control" id="clefRIB"
                        [(ngModel)]="selectedRow.tarif" autocomplete="off"
                        (keydown.enter)="common.focusNext('.modalFicheClient')">
                    <button *ngIf="selectedRow.isTarifQte"
                        (click)="showTarifQte(); common.openModal(modalService, tarifQte)">
                        Définir </button>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Date de début :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <app-input-date [class]="'form-control'" [id]="'date'" [model]="selectedRow.modelDebut"
                        (changefct)="selectedRow.modelDebut = $event; changeDateDebut($event, selectedRow);"
                        [placeholder]="'Date de début'"
                        (keyenterfct)="common.changeDate($event, selectedRow.modelDebut, '#dateF');" [dateVide]="true"
                        (selectfct)="selectDate($event, '#dateF');" [showDatepicker]="true"
                        [closeDatepickerOnSelect]="true"></app-input-date>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Date de fin :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <app-input-date [class]="'form-control'" [id]="'dateF'" [model]="selectedRow.modelFin"
                        (changefct)="selectedRow.modelFin = $event; changeDateFin($event, selectedRow);"
                        [placeholder]="'Date de fin'"
                        (keyenterfct)="common.changeDate($event, selectedRow.modelFin, '#valeur'); " [dateVide]="true"
                        (selectfct)="selectDate($event, '#valeur');" [showDatepicker]="true"
                        [closeDatepickerOnSelect]="true"></app-input-date>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Zone ciblée :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <app-autocomplete (selectfunction)="selectedRow.zoneClible = $event;initChamp('zoneClible')"
                        [results]="listeZone" [highlight]="true" [label]="''" id="modedepaie listeZone"
                        [selectvalue]="true" [placeholder]="'zone ciblé'" [isCombo]="true"
                        [dropdownclass]="'dropDownPrixNego'" [defaultselected]="selectedRow.zoneClible"
                        [disablefocus]="true"
                        [defaultsearch]="selectedRow.zoneClible ? (selectedRow.zoneClible.libelle || selectedRow.zoneClible.libelleObjetEntite) : 'Tous'">
                    </app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Agence :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px"
                    [ngClass]="{'disabledbutton': selectedRow.chantier && selectedRow.chantier.id}">
                    <app-autocomplete (selectfunction)="selectedRow.agence = $event;initChamp('agence')"
                        [results]="listeAgence" [highlight]="true" [id]="'modedepaie agence'" [isCombo]="true"
                        [defaultselected]="selectedRow.agence" [disablefocus]="true"
                        [defaultsearch]="selectedRow.agence ? selectedRow.agence.libelleObjetEntite : ''"
                        [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Chantier ciblé :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px"
                    [ngClass]="{'disabledbutton': (selectedRow.agence && selectedRow.agence.id) || (selectedRow.zoneClible && selectedRow.zoneClible.id) }">
                    <app-autocomplete [placeholder]="'Chantier'" (searchfunction)="searchChantier($event)"
                        (selectfunction)="selectedRow.chantier = $event; initChamp('chantier')" [disablefocus]="true"
                        [results]="listChantier" [showonclick]="true" [label]="''" id="modedepaie autoCht"
                        [defaultsearch]="selectedRow.chantier ? ( !selectedRow.chantier.id ? ( selectedRow.chantier.libelleObjetEntite) :  selectedRow.chantier.numChantier) : ''"
                        [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Exutoire :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <app-autocomplete [placeholder]="'Exutoire'" (searchfunction)="searchExutoire($event)"
                        [id]="'modedepaie exutoire'" (selectfunction)="selectedRow.exutoire = $event"
                        [results]="listExutoire" [disablefocus]="true" [showonclick]="true" [label]="''"
                        [defaultselected]="selectedRow.exutoire"
                        [defaultsearch]="selectedRow.exutoire ? (selectedRow.exutoire.libelleObjetEntite || selectedRow.exutoire.nom) : ''"
                        [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Article Contenu :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px"
                    [ngClass]="{'disabledbutton': selectedRow.isFamille}">
                    <app-autocomplete [placeholder]="selectedRow.articleContenantContenu ? '' : 'Article Contenu'"
                        (searchfunction)="searchArticleContenu($event)"
                        (selectfunction)="selectedRow.articleContenantContenu = $event;changeContenu(selectedRow)"
                        [notOblig]="true" [label]="''" [selectvalue]="true" [results]="artContenu"
                        [id]="'modedepaie artContenu'" [disablefocus]="true"
                        [defaultsearch]="selectedRow.articleContenantContenu ? (selectedRow.articleContenantContenu.libelle || selectedRow.articleContenantContenu.libelleObjetEntite) : 'Tous'"
                        [autohide]="true" (keyenterfunction)="common.focusNext('.ligneBon');"
                        [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Famille Article Contenu :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <div>
                        <mat-checkbox [color]="'primary'" [(ngModel)]="selectedRow.isFamille"
                            (ngModelChange)="changeFamilleArt(selectedRow)"></mat-checkbox>
                    </div>
                    <div class="col-sm-12" style="padding: 0" [ngClass]="{'disabledbutton': !selectedRow.isFamille}">
                        <app-autocomplete (selectfunction)="selectedRow.typeArticle = $event;"
                            [results]="listFamilleArt" [highlight]="true" [id]="'modedepaie  typeArticle'"
                            [isCombo]="true" [disablefocus]="true" [label]="''" [dropdownclass]="'dropDownPrixNego'"
                            [defaultselected]="selectedRow.typeArticle"
                            [defaultsearch]="selectedRow.typeArticle ? selectedRow.typeArticle.libelleObjetEntite || selectedRow.typeArticle.libelle : ''">
                        </app-autocomplete>
                    </div>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Contenant :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px"
                    [ngClass]="{'disabledbutton': !selectedRow.article || (selectedRow.article && !selectedRow.article.id) || isFamille2 }">
                    <app-autocomplete (selectfunction)="selectedRow.contenant = $event;" [isCombo]="true"
                        [results]="listTypeContenant" [disablefocus]="true" [highlight]="true" [label]="''"
                        id="modedepaie typecontenants" [selectvalue]="true" [placeholder]="'Type contenant'"
                        [defaultselected]="selectedRow.contenant"
                        [defaultsearch]="selectedRow.contenant ? selectedRow.contenant.libelleObjetEntite : 'Tous'"
                        [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Matériel :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <app-autocomplete [placeholder]="'Matériel'" (searchfunction)="searchListCamion($event)"
                        [id]="'modedepaie materiel'" (selectfunction)="selectedRow.camion = $event"
                        [results]="listMateriel" [dropdownclass]="'dropDownPrixNego'" [label]="''"
                        [defaultselected]="selectedRow.camion" [disablefocus]="true"
                        [defaultsearch]="selectedRow.camion ? selectedRow.camion.immatriculation || selectedRow.camion.libelleObjetEntite : ''">
                    </app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Prix Franco :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <div>
                        <mat-checkbox [color]="'primary'" [(ngModel)]="selectedRow.prixFranco"></mat-checkbox>
                    </div>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Commentaires :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input type="text" class="form-control" [(ngModel)]="selectedRow.commentaire" autocomplete="off"
                        (keydown.enter)="common.focusNext('.modalFicheClient')">
                </div>
            </div>
            <div class="form-group items col-sm-12" *ngIf="isPNArt">
                <label class="col-sm-3 champ" style="padding:0px">
                    Creer PN de l'article :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <div>
                        <mat-checkbox [color]="'primary'" [(ngModel)]="selectedRow.PNToCreate"></mat-checkbox>
                    </div>
                </div>
            </div>
            <div class="form-group items col-sm-12" *ngIf="isPNArt">
                <label class="col-sm-3 champ" style="padding:0px">
                    Tarif :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input type="number" class="form-control" [(ngModel)]="selectedRow.tarifPN" autocomplete="off"
                        [disabled]="!selectedRow.PNToCreate" (keydown.enter)="common.focusNext('.modalFicheClient')">
                </div>
            </div>
            <div class="form-group items col-sm-12" *ngIf="isPNArt">
                <label class="col-sm-3 champ" style="padding:0px">
                    Seuil Fact :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <div>
                        <mat-checkbox [color]="'primary'" [disabled]="!selectedRow.PNToCreate"
                            [(ngModel)]="selectedRow.seuilFactPN"></mat-checkbox>
                    </div>
                </div>
            </div>
            <div class="form-group items col-sm-12" *ngIf="isPNArt">
                <label class="col-sm-3 champ" style="padding:0px">
                    Seuil :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input type="text" class="form-control" [(ngModel)]="selectedRow.qteSeuilPN" autocomplete="off"
                        [disabled]="!selectedRow.seuilFactPN || !selectedRow.PNToCreate"
                        (keydown.enter)="common.focusNext('.modalFicheClient')">
                </div>
            </div>
        </div>
    </div>
</div>

<div class="col-sm-12 detail" style="height: 100%; padding: 0px" *ngIf="isReconduire" (click)="common.outSide($event)">
    <div class="modal-header col-sm-12" style="padding: 5px;" (click)="common.outSide($event)">
        <h4 class="modal-title pull-left col-sm-8"> Reconduction des prix négociés </h4>
        <div class="col-sm-4 text-right">
            <button type="button" class="btn-header uppercase"
                (click)="selectedRow = {};isReconduire = false; dateReconduction = '';recalculWidth();"> Fermer
            </button>
            <button type="button" class="btn-header uppercase actionPricipal" (click)="saveReconduction();"> Valider
            </button>
        </div>
    </div>
    <div class="modalFicheClient col-sm-12">
        <div class="col-sm-12" style="height: 100%;">
            <div class="col-sm-12"> La date de reconduction doit être supérieure au : {{ changeDateShow().dateFin }}
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-5 champ" style="padding:0px">
                    Date de fin :
                </label>
                <div class="col-sm-7 champ" style="padding-right: 0px">
                    <app-input-date [class]="'form-control'" [id]="'dateF'" (changefct)="changeDate($event)"
                        [placeholder]="'Date Fin'"
                        (keyenterfct)="common.changeDate($event, dateReconduction, '#valeur'); " [showDatepicker]="true"
                        [closeDatepickerOnSelect]="true"></app-input-date>
                    <!--input type="text" class="form-control" id="clefIBAN" [(ngModel)]="dateReconduction"
                        autocomplete="off" (keydown.enter)="common.focusNext('.modalFicheClient')"-->
                </div>
            </div>
            <div class="col-sm-12" style="padding:0">
                <label class="col-sm-6 headerReconduction" style="font-size: 15px;">
                    Prix négociés
                </label>
                <label class="col-sm-6 headerReconduction" style="font-size: 15px;">
                    Prix à reconduire
                    <i class="fa fa-arrow-circle-left text-right  pull-right" aria-hidden="true"
                        (click)="revertReconduction();"></i>
                </label>
            </div>

            <!-- Liste de gauche -->
            <div class='col-sm-6 list-groups' dragula="PERSON" id="left" [(dragulaModel)]="listDerPrixNeg">
              <div class="itemDragDrop itemDragDropPN" *ngFor="let item of listDerPrixNeg">
                <span >
                  {{item.libelleAffiche || "" }}
                </span>
              </div>
            </div>

            <!-- Liste de droite -->
            <div class='col-sm-6 list-groups' dragula="PERSON" id="right" [(dragulaModel)]="listPrixReconduire">
              <div class="itemDragDrop" *ngFor="let item of listPrixReconduire">
                    <span *ngIf="item.libelleAffiche" >{{item.libelleAffiche || "" }} </span> 
                    <span *ngIf="!item.libelleAffiche && item.article">
                      {{ item.article.libelle }} {{ item.dateFin?.length === 10 ? ' - ' + item.dateFin : item.dateFin ? ' - ' + item.dateFin.slice(0, -9) : '' }}
                      {{ item.exutoire?.nom ? ' - ' + item.exutoire.nom : '' }}
                      {{ item.chantier?.id > 0 ? ' - ' + ((item.chantier.numChantier || '') + '/' + (item.chantier.responsable || '') + '/' + (item.chantier.adresse1 || '') + '/' + (item.chantier.ville || '')) : '' }}
                    </span>
                    <span *ngIf="!item.libelleAffiche && !item.article && item.operationBenne">
                      {{ item.operationBenne.libelle }} {{ item.dateFin?.length === 10 ? ' - ' + item.dateFin : item.dateFin ? ' - ' + item.dateFin.slice(0, -9) : '' }}
                      {{ item.exutoire?.nom ? ' - ' + item.exutoire.nom : '' }}
                      {{ item.chantier?.id > 0 ? ' - ' + ((item.chantier.responsable || '') + '/' + (item.chantier.responsable || '') + '/' + (item.chantier.adresse1 || '') + '/' + (item.chantier.ville || '')) : '' }}
                    </span>
                <i class="fa fa-times text-right pull-right" aria-hidden="true"
                  (click)="removeReconduction(item);"></i>
              </div>
            </div>
        </div>
    </div>
</div>

<ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg" [innerHTML]="error"> </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
            </button>
        </div>
    </div>
</ng-template>

<ng-template #tarifQte>
    <div class="modal-body" style="height: auto">
        <div style="height:400px;">
            <app-tarif-quantite [listTarifQte]="listTarifQte" [showQteSupp]="true"
                [valeurQteSupp]="selectedRow.article.isQteSupp" (hidefunction)="hideModal()"
                (validefunction)="saveTarifQte($event)"></app-tarif-quantite>
        </div>
    </div>
</ng-template>

<ng-template #verImprimable>
    <div class="modal-header">
        <h4 class="modal-title pull-left"> Choix de la famille : </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body modalFicheClient" style="height: auto">
        <div class="col-sm-12" style="padding: 0px;">
            <div class="form-group items col-sm-12">
                <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                    [(ngModel)]="familleImprimable">
                    <mat-radio-button [color]="'primary'" class="example-radio-button" *ngFor="let item of listCombo"
                        [value]="item.id">
                        {{item.libelleObjetEntite}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
        <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
            <button type="button" class=" btn-close btn-valider" (click)="valideVerImprimable(); common.closeModal();">
                Valider
            </button>
            <button type="button" class=" btn-close" (click)="common.closeModal();"> Annuler </button>
        </div>
    </div>
</ng-template>

<ng-template #xls>
    <div class="modal-header">
        <h4 class="modal-title pull-left"> Choix de la famille : </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body modalFicheClient" style="height: auto">
        <div class="col-sm-12" style="padding: 0px;">
            <div class="form-group items col-sm-12">
                <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                    [(ngModel)]="familleXls">
                    <mat-radio-button [color]="'primary'" class="example-radio-button" *ngFor="let item of listCombo"
                        [value]="item.id">
                        {{item.libelleObjetEntite}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
        <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
            <button type="button" class=" btn-close btn-valider" (click)="valideXls(); common.closeModal();">
                Valider
            </button>
            <button type="button" class=" btn-close" (click)="common.closeModal();"> Annuler </button>
        </div>
    </div>
</ng-template>

<ng-template #loading>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg loadingpopup"> Cette opération peut prendre plusieurs minutes. Veuillez
                    patienter. </label>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #popTemplate>
    <div style="width: 210px" *ngIf="articleHover">
        <table class="tablepopover">
            <tr>
                <th>Qte</th>
                <th>Tarif</th>
            </tr>
            <ng-template ngFor let-qte [ngForOf]="articleHover.listTarifQte">
                <tr>
                    <th>{{qte.quantite}} {{articleHover.unite}} </th>
                    <th>{{common.toFixed(qte.tarif || '0')}}</th>
                </tr>
            </ng-template>
        </table>
        <p>
            Qte supp sur dernier prix : {{ articleHover.isQteSupp ? 'OUI' : 'NON'}}
        </p>
    </div>
</ng-template>


<ng-template #choixDateFin>
    <div class="modal-header">
        <h4 class="modal-title pull-left"> Choix de la date fin </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body modalChoixDateFin">
        <div class="col-sm-12" style="padding: 0px;">
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Date de fin :
                </label>
                <div class="col-sm-9 champ">
                    <app-input-date [class]="'form-control'" [id]="'date'" [model]="modelDateFinSel"
                        (changefct)="modelDateFinSel = $event; changeDateSel($event);" [placeholder]="'Date fin'"
                        (keyenterfct)="common.changeDate($event, modelDateFinSel, '#dateF');" [showDatepicker]="true"
                        [closeDatepickerOnSelect]="true">
                    </app-input-date>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn-close btn-valider" (click)="valideChoixDate();">
                Valider
            </button>
            <button type="button" class="btn-close" (click)="common.closeModal();">
                Annuler
            </button>
        </div>
    </div>

</ng-template>

<div class="spinner" id="spinnerCont" *ngIf="isClick">
    <div class="sk-fading-circle">
        <div class="sk-circle1 sk-circle"></div>
        <div class="sk-circle2 sk-circle"></div>
        <div class="sk-circle3 sk-circle"></div>
        <div class="sk-circle4 sk-circle"></div>
        <div class="sk-circle5 sk-circle"></div>
        <div class="sk-circle6 sk-circle"></div>
        <div class="sk-circle7 sk-circle"></div>
        <div class="sk-circle8 sk-circle"></div>
        <div class="sk-circle9 sk-circle"></div>
        <div class="sk-circle10 sk-circle"></div>
        <div class="sk-circle11 sk-circle"></div>
        <div class="sk-circle12 sk-circle"></div>
    </div>
</div>